import { fragments as customizationAreaListFragments } from "../CustomizationAreaList/graph";
import { fragments as designProofListFragments } from "../../../../../components/DesignProofList/graph";
import { filter } from "graphql-anywhere";
import { makeStyles } from "@mui/styles";
import { fragments as productQuantitySummaryFragments } from "../../components/ProductQuantitySummary/graph";
import { query } from "./graph";
import { useQuery } from "@apollo/client";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CustomerArtworkModal from "../CustomerArtworkModal";
import CustomizationAreaList from "../CustomizationAreaList";
import DesignProofList from "../../../../../components/DesignProofList";
import PendingStatusView from "../../../../../components/PendingStatusView";
import ProductQuantitySummary from "../../components/ProductQuantitySummary";
import React, { useState } from "react";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  columnContainer: {
    display: "flex",
    flexWrap: "nowrap"
  },
  columnLeft: {
    display: "flex",
    flexDirection: "column"
  },
  columnLeftContainer: {
    flex: "1 1 40%",
    minWidth: "250px",
    paddingRight: theme.spacing(2)
  },
  columnRightContainer: {
    flex: "1 1 60%"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap"
  },
  customerOriginalsButton: {
    marginBottom: theme.spacing(1)
  },
  header: {
    marginBottom: theme.spacing(1),
    minWidth: "460px"
  },
  moduleSpacing: {
    marginBottom: theme.spacing(2)
  }
}));

const ProductionJobDetail = ({ orderProductionJobId }) => {
  const classes = useStyles();
  const { data, loading, error } = useQuery(query, {
    variables: { orderProductionJobId }
  });
  const [showCustomerArtworkModal, setShowCustomerArtworkModal] =
    useState(false);

  const handleViewCustomerOriginalsButtonClick = () => {
    setShowCustomerArtworkModal(true);
  };

  const handleCustomerArtworkModalRequestClose = () => {
    setShowCustomerArtworkModal(false);
  };

  if (loading) return <PendingStatusView status="Loading" />;
  if (error)
    return (
      <Typography variant="body2" color="error">
        There was an error while attempting to load this order.
      </Typography>
    );
  if (!data?.orderProductionJob)
    return (
      <Typography variant="body2" color="error">
        Unfortunately, that order could not be located.
      </Typography>
    );

  return (
    <div className={classes.container}>
      <div className={classes.columnContainer}>
        <div className={classes.columnLeftContainer}>
          <div className={classes.header}>
            <Typography variant="h6">Print Area(s) & Artwork</Typography>
          </div>
          <Card>
            <CardContent>
              <Button
                className={classes.customerOriginalsButton}
                color="primary"
                onClick={handleViewCustomerOriginalsButtonClick}
                variant="outlined"
              >
                View Customer Originals
              </Button>
              <div className={classes.columnLeft}>
                <DesignProofList
                  proofs={filter(
                    designProofListFragments.proofs,
                    data.orderProductionJob.filteredProofs
                  )}
                />
              </div>
            </CardContent>
          </Card>
        </div>
        <div className={classes.columnRightContainer}>
          <div>
            <div className={classes.moduleSpacing}>
              <CustomizationAreaList
                customizationAreas={filter(
                  customizationAreaListFragments.customizationAreas,
                  data.orderProductionJob.customizationAreas
                )}
              />
            </div>
            <div className={classes.moduleSpacing}>
              <ProductQuantitySummary
                productionJob={filter(
                  productQuantitySummaryFragments.productionJob,
                  data.orderProductionJob
                )}
              />
            </div>
            <CustomerArtworkModal
              isOpen={showCustomerArtworkModal}
              orderProductionJobId={data.orderProductionJob.id}
              onRequestClose={handleCustomerArtworkModalRequestClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductionJobDetail;
